<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 금리 안내(정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>NZD</h6>
      <div class="tbl-top-etc">{{/*(연이율, 세전, 단위 : %)*/$t("MDEP-01-02-01-08")}}</div>
    </div>
    <table class="table -type01">
      <thead>
        <tr>
          <th class="division" scope="col"></th>
          <th scope="col">
            $5,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $10,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $50,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
        </tr>
      </thead>
      <tbody v-if="termDepositListNZD.length > 0">
        <tr v-for="(td1, i) in termDepositListNZD" :key="i">
          <th scope="row">
            {{
              lang == $config.LANG_KOR
              ? td1.aplyTrmCtntKor
              : td1.aplyTrmCtntEng
            }}
          </th>
          <td>{{ td1.mtS5000Rate }}</td>
          <td>{{ td1.mtS10000Rate }}</td>
          <td>{{ td1.mtS50000Rate }}</td>
          <td>{{ td1.mtS100000Rate }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">{{/*중도해지 : 약정이율 –2% 이거나 0%*/$t("MDEP-01-02-02-07")}}</div>

    <div class="cont-tit">
      <h6>USD</h6>
      <div class="tbl-top-etc">{{/*(연이율, 세전, 단위 : %)*/$t("MDEP-01-02-01-08")}}</div>
    </div>
    <table class="table -type01">
      <thead>
        <tr>
          <th class="division" scope="col"></th>
          <th scope="col">
            $5,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $10,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $50,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
        </tr>
      </thead>
      <tbody v-if="termDepositListUSD.length > 0">
        <tr v-for="(td2, j) in termDepositListUSD" :key="j">
          <th scope="row">
            {{
              lang == $config.LANG_KOR
              ? td2.aplyTrmCtntKor
              : td2.aplyTrmCtntEng
            }}
          </th>
          <td>{{ td2.mtS5000Rate }}</td>
          <td>{{ td2.mtS10000Rate }}</td>
          <td>{{ td2.mtS50000Rate }}</td>
          <td>{{ td2.mtS100000Rate }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">{{/*중도해지 : 약정이율 –2% 이거나 0%*/$t("MDEP-01-02-02-07")}}</div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 1,

      termDepositListNZD: [],
      termDepositListUSD: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateNz1List";

      let params1 = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "NZD",
          dpostLnDstcd: "D",
          operGroupCd: "NZ1",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "NZ102"
        },
      };

      let params2 = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "USD",
          dpostLnDstcd: "D",
          operGroupCd: "NZ1",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "NZ102"
        },
      };

      // 정기예금 - NZD
      this.$post(
        path,
        params1,
        this.selectSucc1
      );

      // 정기예금 - USD
      this.$post(
        path,
        params2,
        this.selectSucc2
      );
    },

    selectSucc1(res) {
      this.termDepositListNZD = res.interstList;
    },
    selectSucc2(res) {
      this.termDepositListUSD = res.interstList;
    },
  },
};
</script>
